import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ChevronsUp = createReactComponent("ChevronsUp", ["svg", defaultAttributes, [["polyline", {
  points: "17 11 12 6 7 11",
  key: "pbh56f"
}], ["polyline", {
  points: "17 18 12 13 7 18",
  key: "4kr3s3"
}]]]);
export default ChevronsUp;